import Backbone from 'backbone';
import { on, off, getElement } from 'utils/mixins';
import BaseAPI from '../../../services/BaseAPI';
import Tools from '../../../services/Tools';
const $ = Backbone.$;

module.exports = Backbone.View.extend({
  tagName: 'div',

  template() {
    const type = this.model.get('type');
    let width_btn = 110;
    if (type == 1) {
      return `
            <style>
              .btn:hover {
                filter: brightness(80%);
              }
            </style>
            <div class="header"> Đánh giá cuộc hội thoại</div> 
            <div class="conten">
              <div class='title'> Bạn đánh giá thế nào về cuộc hội thoại này?</div> 
              <div class="rate">
                  <input type="radio" id="star5" name="rate" value="5" />
                  <label for="star5" title="text">5 stars</label>
                  <input type="radio" id="star4" name="rate" value="4" />
                  <label for="star4" title="text">4 stars</label>
                  <input type="radio" id="star3" name="rate" value="3" />
                  <label for="star3" title="text">3 stars</label>
                  <input type="radio" id="star2" name="rate" value="2" />
                  <label for="star2" title="text">2 stars</label>
                  <input type="radio" id="star1" name="rate" value="1" />
                  <label for="star1" title="text">1 star</label>
              </div>
            </div>
            <div class="footer">
              <div style="background-color:${this.conf.header_color}; color:${this.conf.text_header_color};" class="send btn">Gửi</div>
            </div>`;
    } else {
      return `
        <style>
          .btn:hover {
            filter: brightness(80%);
          }
        </style>
        <div class="header">Thông báo</div> 
        <div class="conten">
          <div class="title"> Cảm ơn bạn đã nhắn tin cho chúng tôi. Nếu bạn cần thêm thông tin, hãy bắt đầu một cuộc chat mới với chúng tôi.</div> 
        </div>
        <div class="footer">
          <div style=" width: ${width_btn}px; background-color:${this.conf.header_color}; color:${this.conf.text_header_color};" class="agreeClick btn">Bắt đầu chat</div>
        </div>`;
    }
  },

  initialize(o) {
    _.bindAll(this, 'renderContent');
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
  },
  renderContent() {
    const { $el, model, conf } = this;
    const that = this;
    $el.html(this.template());

    $el.find('.send').on('click', function(params) {
      model.set('type', 2);
      const session_id = Tools.getSessionId(conf.domain_id);
      const userId = conf.userId || Tools.getUserId(conf.domain_id);

      var confix = {
        url: `${conf.domainAPI}/session/${session_id}/actions/rating`,
        method: 'POST',
        body: {
          content: '',
          rating_star: $el.find('.rate>input:checked ~ label').length
        }
      };
      var headers = {
        cid: userId
      };
      BaseAPI.callAPI(
        confix,
        headers,
        response => {
          $el.html(that.template());
          $el.find('.agreeClick').on('click', function(params) {
            model.trigger('agreeClick');
          });
        },
        error => {
          console.log('error', error);
        }
      );
    });
  },

  render() {
    const { $el, model } = this;
    $el.attr({ class: `${this.pfx}myrating`, id: 'myrating' });
    this.renderContent();
    return this;
  }
});
